<template>
  <div class="date-selector-wrapper">
    <div
      v-show="showSpinner"
      class="spinner-border"
      style="margin: auto; display: block; margin-top: 60px"
    ></div>
    <div v-show="!showSpinner">
      <div class="form-group row">
        <div class="col-sm-2">
          <p>StartDate</p>
        </div>
        <div class="col-sm-4">
          <b-form-datepicker
            id="start-date-selector-"
            name="startDate"
            placeholder="Start date"
            class="date_wrapper padding-custom"
            v-model="start_date"
            menu-class="w-100"
            size="sm"
            :date-format-options="{
              day: '2-digit',
              month: '2-digit',
              year: 'numeric',
            }"
            calendar-width="200%"
            :hide-header="true"
            :today-button="false"
            :min="todays_date"
            locale="en"
            @input="checkEndDate();dateUpdated('startDate')"
          ></b-form-datepicker>
        </div>

        <!-- <div class="col-sm-2">
          <span>
            <input type="radio" value="today" v-model="checkedStartdate" />
            Today
          </span>
        </div> -->
        <div class="col-sm-3">
          <span>
            <input type="radio" value="tomorrow" v-model="checkedStartdate" />
            Tomorrow
          </span>
        </div>
      </div>
      <div class="form-group row">
        <div class="col-sm-2"><p>End Date</p></div>
        <div class="col-sm-4">
          <b-form-datepicker
            id="end-date-selector_"
            name="endDate"
            placeholder="End date"
            class="date_wrapper padding-custom"
            v-model="end_date"
            menu-class="w-100"
            size="sm"
            :date-format-options="{
              day: '2-digit',
              month: '2-digit',
              year: 'numeric',
            }"
            calendar-width="200%"
            :hide-header="true"
            :today-button="false"
            :min="findMinDate()"
            locale="en"
            @input="dateUpdated('endDate')"
          ></b-form-datepicker>
        </div>
      </div>
      <div class="form-group row">
        
        <div class="col-sm-2"><p>Enable Time</p></div>
        <div class="col-sm-4">
          <multiselect
            v-model="endTimeObj"
            :options="time_list"
            :searchable="true"
            placeholder="HH:mm"
            ref="multiselect"
            track-by="hourminute"
            label="hourminute"
            open-direction="up"
            class="form-control multi-dropdown"
            selectLabel
            deselectLabel
            selectedLabel
            autocomplete="off"
            :multiple="false"
            :taggable="false"
            id="endTime"
            @input="timeUpdated('endTime')"
          ></multiselect>
        </div>
        <div class="col-sm-2"><p>Pause Time</p></div>
        <div class="col-sm-2">
          <multiselect
            v-model="startTimeObj"
            :options="time_list"
            :searchable="true"
            placeholder="HH:mm"
            ref="multiselect"
            track-by="hourminute"
            label="hourminute"
            open-direction="up"
            class="form-control multi-dropdown"
            selectLabel
            deselectLabel
            selectedLabel
            autocomplete="off"
            style="max-height: 40px"
            :multiple="false"
            :taggable="false"
            id="startTime"
            @input="timeUpdated('startTime')"
          ></multiselect>
        </div>
        <div class = "col-sm-2" style = "color:red"><p>Time in CST</p></div>
      </div>
    </div>
  </div>
</template>
<script>
var moment = require("moment");
import Multiselect from "vue-multiselect";
export default {
  name: "DayPartingData",
  props: ["partingEndDate", "partingStartDate", "partingStartTime", "partingEndTime"],
  watch: {
    checkedStartdate() {
      if (this.checkedStartdate == "today") {
        this.start_date = moment(Date.now()).format("YYYY-MM-DD");
        this.dateUpdated('startDate')
      } else if (this.checkedStartdate == "tomorrow") {
        this.start_date = moment().add(1, "days").format("YYYY-MM-DD");
        this.dateUpdated('startDate')
        this.checkEndDate()
      }
    },
  },
  data() {
    return {
      start_date:this.partingStartDate,
      end_date:this.partingEndDate,
      startTimeObj:this.partingStartTime?{'hourminute':this.partingStartTime.slice(0,5)}:null,
      endTimeObj:this.partingEndTime?{'hourminute':this.partingEndTime.slice(0,5)}:null,
      showSpinner: false,
      manageDayParting: true,
      checkedStartdate: "",
      todays_date: "",
      showOthers: true,
      checked_mnso_start_time: "",
      checked_mnso_end_time: "",
      time_list: [],
      hour_gap: 1,
      minute_gap: 0,
      start_min: 0,
      start_hour: 0,
      end_min: 0,
      end_hour: 23,
    };
  },
  components: {
    Multiselect,
  },
  mounted() {
    this.todays_date = moment(Date.now()).add(1, 'days').format("YYYY-MM-DD");
    this.setTimeList();

    let today = moment(new Date()).format("YYYY-MM-DD");
    let tomorrow = moment().add(1, "days").format("YYYY-MM-DD");
    if (this.start_date && this.start_date == today && this.start_date != tomorrow) {
      this.checkedStartdate = "today";
    } else if (this.start_date && this.start_date != today && this.start_date == tomorrow) {
      this.checkedStartdate = "tomorrow";
    } else {
      this.checkedStartdate = "";
    }

  },
  methods: {
    moment,
    dateUpdated(type){
      if(type=='startDate'){
        this.$emit('updateDate','startDate',this.start_date)
      }
      if(type=='endDate'){
        this.$emit('updateDate','endDate',this.end_date)
      }
    },
    timeUpdated(type){
      if(type=='startTime'){
        let time = this.startTimeObj?this.startTimeObj.hourminute:null
        this.$emit('updateTime','startTime',time)
      }
      if(type=='endTime'){
        let time = this.endTimeObj?this.endTimeObj.hourminute:null
        this.$emit('updateTime','endTime',time)
      }
    },
    checkEndDate() {
      
      let today = moment(new Date()).format("YYYY-MM-DD");
      let tomorrow = moment().add(1, "days").format("YYYY-MM-DD");
      if (this.start_date && this.start_date == today && this.start_date != tomorrow) {
        this.checkedStartdate = "today";
      } else if (this.start_date && this.start_date != today && this.start_date == tomorrow) {
        this.checkedStartdate = "tomorrow";
      } else {
        this.checkedStartdate = "";
      }
      if (!this.start_date || !this.end_date) {
        return;
      }
      if (
        this.end_date &&
        moment(this.end_date).isBefore(moment(this.start_date))
      ) {
        this.end_date = "";
        this.dateUpdated('endDate')
      }
      // if (this.start_date == today && this.start_date != tomorrow) {
      //   this.checkedStartdate = "today";
      // } else if (this.start_date != today && this.start_date == tomorrow) {
      //   this.checkedStartdate = "tomorrow";
      // } else {
      //   this.checkedStartdate = "";
      // }
    },
    findMinDate() {
      let today = moment(new Date()).utc().format("YYYY-MM-DD");
      if (this.start_date) {
        if (moment(this.start_date).isBefore(moment(today))) {
          return today;
        } else {
          return this.start_date;
        }
      } else {
        return today;
      }
    },
    setTimeList() {
      this.time_list = [];
      for (var i = this.start_hour; i <= this.end_hour; i = i + this.hour_gap) {
        let obj = {};
        let min = this.start_min;
        obj["hour"] = i;
        obj["min"] = min;
        if (min < this.end_min) {
          min = min + this.minute_gap;
        } else {
          min = this.start_min;
        }
        if (obj["hour"].toString().length == 1) {
          obj["hour"] = "0" + obj["hour"];
        }
        if(obj['min'].toString().length == 1){
          obj['min'] = '0' + obj['min']
        }
        obj["hourminute"] = obj["hour"] + ":" + obj["min"];
        this.time_list.push(obj);
      }
    },
  },
};
</script>